const APP_CONFIG = {};
switch (window.location.hostname) {
  case 'localhost':
    APP_CONFIG.app_name_prefix = 'lw';
    APP_CONFIG.app_name = 'LOGÍSTICA WOODWARD';
    APP_CONFIG.logo_light = '/img/logo/logo-lw-light-full.png';
    APP_CONFIG.logo_dark = '/img/logo/logo-lw-dark-full.png';
    APP_CONFIG.auth_side_bg = '/img/others/auth-side-bg.jpg';
    APP_CONFIG.RECAPTCHA_V2_SITE_KEY =
      '6LcbqiosAAAAACLjwUTpDrGtftGSBYI2Yn_SXE0I';
    APP_CONFIG.RECAPTCHA_V3_SITE_KEY =
      '6LcznSosAAAAAA8ejL5wAJcrFxh5X7mRipiWAjBd';
    break;
  case 'apexlw.woodward.mx':
  case 'apexlw.uat.woodward.mx':
  case 'apexlw.dev.woodward.mx':
    APP_CONFIG.app_name_prefix = 'lw';
    APP_CONFIG.app_name = 'LOGÍSTICA WOODWARD';
    APP_CONFIG.logo_light = '/img/logo/logo-lw-light-full.png';
    APP_CONFIG.logo_dark = '/img/logo/logo-lw-dark-full.png';
    APP_CONFIG.auth_side_bg = '/img/others/auth-side-bg.jpg';
    APP_CONFIG.RECAPTCHA_V2_SITE_KEY =
      '6LcbqiosAAAAACLjwUTpDrGtftGSBYI2Yn_SXE0I';
    APP_CONFIG.RECAPTCHA_V3_SITE_KEY =
      '6LcznSosAAAAAA8ejL5wAJcrFxh5X7mRipiWAjBd';
    break;
  case 'portal.olce.com.mx':
  case 'portal.uat.olce.com.mx':
  case 'portal.dev.olce.com.mx':
    APP_CONFIG.app_name_prefix = 'olce';
    APP_CONFIG.app_name = 'ORGANIZACIÓN DE LOGÍSTICA EN COMERCIO EXTERIOR';
    APP_CONFIG.logo_light = '/img/logo/logo-olce-light-full.png';
    APP_CONFIG.logo_dark = '/img/logo/logo-olce-dark-full.png';
    APP_CONFIG.auth_side_bg = '/img/others/auth-side-bg-olce.png';
    APP_CONFIG.RECAPTCHA_V2_SITE_KEY =
      '6LcbqiosAAAAACLjwUTpDrGtftGSBYI2Yn_SXE0I';
    APP_CONFIG.RECAPTCHA_V3_SITE_KEY =
      '6LcznSosAAAAAA8ejL5wAJcrFxh5X7mRipiWAjBd';
    break;
  default:
    break;
}

const FRONTEND_PORT = 3000;
const BACKEND_PORT = 3001;

const isLocalhost = window.location.hostname === 'localhost';

const API_URL = isLocalhost
  ? window.location.protocol +
    '//' +
    window.location.hostname +
    `:${BACKEND_PORT}`
  : window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? `:${BACKEND_PORT}` : '');

const WEBSITE_URL =
  window.location.protocol +
  '//' +
  window.location.hostname +
  (window.location.port ? `:${FRONTEND_PORT}` : '');

const appConfig = {
  apiPrefix: '/api',
  apiUrl: API_URL,
  websiteUrl: WEBSITE_URL,
  authenticatedEntryPath: '/core/prin/inic-dash/dashboard/',
  unAuthenticatedEntryPath: '/core/prin/inic-sesi/iniciar-sesion/',
  tourPath: '/',
  enableMock: false,
  ...APP_CONFIG
};

export default appConfig;
